import { c as _c } from "react/compiler-runtime";
import { IcoImages24 } from '@onefootprint/icons';
import { Button } from '@onefootprint/ui';
import { motion } from 'framer-motion';
import { Trans, useTranslation } from 'react-i18next';
import NavigationHeader from '@/idv2/features/collect-document/components/navigation-header';
import HeaderTitle from '../header-title';
type CameraAccessRequestViewProps = {
  onClose: () => void;
  onAllowAccess: () => void;
  isLoading?: boolean;
  variant?: 'document' | 'selfie';
};
const CameraAccessRequestView = t0 => {
  const $ = _c(48);
  const {
    onClose,
    onAllowAccess,
    isLoading,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "document" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "document-flow"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t2);
  let t3;
  if ($[1] !== t || $[2] !== variant) {
    t3 = variant === "selfie" ? t(_temp) : t(_temp2);
    $[1] = t;
    $[2] = variant;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const youWillUseBody = t3;
  let t4;
  if ($[4] !== t || $[5] !== variant) {
    t4 = variant === "selfie" ? t(_temp3) : t(_temp4);
    $[4] = t;
    $[5] = variant;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const weWillUseBody = t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      opacity: 0
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  let t7;
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      opacity: 1,
      transition: {
        duration: 0.3
      }
    };
    t7 = {
      opacity: 0
    };
    t8 = <style>{"\n          @media (max-width: 899px) {\n            #footprint-footer { display: none; }\n            #idv-body-content-container > div { padding-bottom: 0; }\n          }\n        "}</style>;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t6 = $[8];
    t7 = $[9];
    t8 = $[10];
  }
  let t9;
  if ($[11] !== onClose) {
    t9 = <NavigationHeader leftButton={{
      variant: "back",
      onBack: onClose
    }} />;
    $[11] = onClose;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t) {
    t10 = t(_temp5);
    $[13] = t;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10) {
    t11 = <HeaderTitle title={t10} display="flex" flexDirection="column" />;
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="shrink-0"><IcoImages24 color="primary" /></div>;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <p className="text-label-2 text-primary"><Trans ns="idv2" i18nKey={_temp6} components={{
        underlined: <span className="underline" />
      }} /></p>;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== youWillUseBody) {
    t14 = <div className="flex gap-3 items-start">{t12}<div>{t13}<p className="text-body-2 text-tertiary">{youWillUseBody}</p></div></div>;
    $[19] = youWillUseBody;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="shrink-0"><IcoImages24 color="primary" /></div>;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <p className="text-label-2 text-primary"><Trans ns="idv2" i18nKey={_temp7} components={{
        underlined: <span className="underline" />
      }} /></p>;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== weWillUseBody) {
    t17 = <p className="text-body-2 text-tertiary">{weWillUseBody}</p>;
    $[23] = weWillUseBody;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== t) {
    t18 = t(_temp8);
    $[25] = t;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== t18) {
    t19 = <p className="text-label-2 text-primary">{t18}</p>;
    $[27] = t18;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== t17 || $[30] !== t19) {
    t20 = <div className="flex gap-3 items-start">{t15}<div>{t16}{t17}{t19}</div></div>;
    $[29] = t17;
    $[30] = t19;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  let t21;
  if ($[32] !== t14 || $[33] !== t20) {
    t21 = <div className="flex flex-col gap-4 w-full">{t14}{t20}</div>;
    $[32] = t14;
    $[33] = t20;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== t) {
    t22 = t(_temp9);
    $[35] = t;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  let t23;
  if ($[37] !== isLoading || $[38] !== onAllowAccess || $[39] !== t22) {
    t23 = <Button fullWidth={true} onClick={onAllowAccess} testID="allow-access" size="large" loading={isLoading}>{t22}</Button>;
    $[37] = isLoading;
    $[38] = onAllowAccess;
    $[39] = t22;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== t11 || $[42] !== t21 || $[43] !== t23) {
    t24 = <div className="flex flex-col items-center flex-1 gap-6">{t11}{t21}{t23}</div>;
    $[41] = t11;
    $[42] = t21;
    $[43] = t23;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== t24 || $[46] !== t9) {
    t25 = <motion.div className="flex flex-col flex-1 h-full" initial={t5} animate={t6} exit={t7}>{t8}{t9}{t24}</motion.div>;
    $[45] = t24;
    $[46] = t9;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  return t25;
};
export default CameraAccessRequestView;
function _temp($) {
  return $["selfie-camera-use"];
}
function _temp2($_0) {
  return $_0["docs-and-or-selfie"];
}
function _temp3($_1) {
  return $_1["selfie-verification-use"];
}
function _temp4($_2) {
  return $_2["key-needed-for-verification"];
}
function _temp5($_3) {
  return $_3["access-camera"];
}
function _temp6($_4) {
  return $_4["document-flow"]["how-you-will-use-this"];
}
function _temp7($_5) {
  return $_5["document-flow"]["how-we-will-use-this"];
}
function _temp8($_6) {
  return $_6["no-camera-access"];
}
function _temp9($_7) {
  return $_7["allow-access"];
}